export default __webpack_public_path__ + "static/media/roboto.a8d6ac03.ttf";